import { useSyncExternalStore } from 'react';

// The "Apply Now" buttons the Drupal theme (page.tpl.php) leaves off some pages. Footer sees the
// address; Page reports whether the page it shows is one of the nodes below.
//
// The sticky bar at the bottom of the window (Footer) is off the application, every conference
// page, the Conferences page (node 777) and DOC Talks (node 201221).
export const NO_STICKY_APPLY_BAR_PAGES = [777, 201221];
// The red button in the header (Header: the phone one above the menu and the desktop menu's last
// item) is off every conference page and the Conferences page; DOC Talks keeps it.
export const NO_HEADER_APPLY_BUTTON_PAGES = [777];

let pageHidesBar = false;
let pageHidesButton = false;
const listeners = new Set();

function notify() {
    listeners.forEach((cb) => cb());
}

export function setPageHidesStickyApplyBar(hides) {
    if (pageHidesBar === hides) return;
    pageHidesBar = hides;
    notify();
}

export function setPageHidesHeaderApplyButton(hides) {
    if (pageHidesButton === hides) return;
    pageHidesButton = hides;
    notify();
}

function subscribe(cb) {
    listeners.add(cb);
    return () => { listeners.delete(cb); };
}

export const usePageHidesStickyApplyBar = () => useSyncExternalStore(subscribe, () => pageHidesBar);
export const usePageHidesHeaderApplyButton = () => useSyncExternalStore(subscribe, () => pageHidesButton);
